import {
    STORE_READING_SESSION_AUDIT,
    STORE_WEEKLY_REPORT_AUDIT,
} from '../../constants/audit';

const initialState = {
    logs: [],
    weeklyReportLogs: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case STORE_READING_SESSION_AUDIT:
            return {
                ...state,
                logs: action.logs || [],
            };
        case STORE_WEEKLY_REPORT_AUDIT:
            return {
                ...state,
                weeklyReportLogs: action.logs || [],
            };
        default:
            return state;
    }
};
